import { render, staticRenderFns } from "./OutrosIcon.vue?vue&type=template&id=56e1a04c&"
import script from "./OutrosIcon.vue?vue&type=script&lang=ts&"
export * from "./OutrosIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports